// extracted by mini-css-extract-plugin
export var configurationSection = "_z6-0";